import { createContext } from "react";

export const FormContextMA = createContext({
  formType: "",
  clinicalServiceName: "",
  patient: {},
  serviceId: null,
  preAssessment: {},
  clinicalAssessment: {},
  signsAndSymptoms: {},
  differentialAssessment: {},
  documentation: {},
  treatment: {},
  education: {},
  startDateTime: "",
  endDateTime: "",
  showReferral: false
});

export const FormContextAMR = createContext({
  formType: "",
  clinicalServiceName: "",
  patient: {},
  serviceId: null,
  preAssessment: {},
  clinicalAssessment: {},
  documentation: {},
  education: {},
  patientMedications: {},
  medications: {},
  startDateTime: "",
  endDateTime: "",
  /** When true, PMR shows "Under Review" watermark + "In Review" pill and must not be given to the patient (outstanding interventions). */
  hasActiveInterventions: undefined,
  /** When true (and no active interventions), PMR shows the "Final Version" pill. Set from a Completed intervention. */
  pmrIsFinal: undefined,
});